import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DataService {

    hideDropdown: boolean = true;

    refreshProjectFiles$ = new Subject<boolean>();

    // Fired when a TP project gets linked to a Robert project mid-session (the client-job save auto-chain or the
    // resource job's "Set up in Robert"), so an open project page can show the header Robert icon / columns
    // without a full reload. The link lands AFTER jobSaved (it is an async follow-up call), so the page's usual
    // post-save refresh reads the project too early — this is the late signal.
    robertProjectLinked$ = new Subject<{ projectId: number; robertProjectId: string }>();

    // Fired when a client job's source file lands in Robert (tasks created + auto-mapped) — the send is an async
    // follow-up of the save, so the project page's post-save row refresh ran before the tasks existed. The page
    // reloads its client-job rows + Robert statuses so the "Robert" column fills in without a page reload.
    robertJobSent$ = new Subject<{ projectId: number; clientJobId: number }>();

    constructor() { }
}
